//Reset data
export const RESET = "USER_UPDATE_RESET"

export const SET_IS_UPDATED = "USER_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "USER_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "USER_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USER_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USER_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USER_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "USER_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USER_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USER_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "USER_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USER_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "USER_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "USER_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USER_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USER_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USER_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "USER_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "USER_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USER_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USER_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USER_UPDATE_SET_MODAL_TYPE"